import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getHomeProfile = async () => {
  const response = await fetchWrapper(
    hcUrl('/home/profile'),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};
